import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from 'yup';

export interface IRoutingModelFormMeta {
  minRangeBin: FormInputMeta,
  maxRangeBin: FormInputMeta,
  transactionType: FormInputMeta,
  AID: FormInputMeta,
  withPinOrNot: FormInputMeta,
  primaryInterface: FormInputMeta,
  secondaryInterface: FormInputMeta,
}

const RoutingForm1Meta: IRoutingModelFormMeta = {} as IRoutingModelFormMeta;

RoutingForm1Meta.minRangeBin = {
  name: 'minRangeBin',
  type: 'select',
  label: 'Min Range Bin',
  validation: yup.string().required(),
};
RoutingForm1Meta.maxRangeBin = {
  name: 'maxRangeBin',
  type: 'text',
  label: 'Max Range Bin',
  validation: yup.string().required(),
};
RoutingForm1Meta.transactionType = {
  name: 'transactionType',
  type: 'select',
  label: 'Type transaction',
  validation: yup.string().required(),
};
RoutingForm1Meta.AID = {
  name: 'AID',
  type: 'text',
  label: 'AID',
  validation: yup.string().required(),
};
RoutingForm1Meta.withPinOrNot = {
  name: 'withPinOrNot',
  type: 'select',
  label: 'Avec ou sans Pin',
  validation: yup.string().required(),
};
RoutingForm1Meta.primaryInterface = {
  name: 'primaryInterface',
  type: 'select',
  label: 'Interface primaire',
  validation: yup.string().required(),
};
RoutingForm1Meta.secondaryInterface = {
  name: 'secondaryInterface',
  type: 'select',
  label: 'Interface secondaire',
  validation: yup.string().required(),
};


export default RoutingForm1Meta;